export default {
  platforms: [],
  platforms_loading: false,
  platforms_submitting: false,
  platforms_error: "",
  active_platform: null,
  is_edit_platform: false,
  has_more: false,
  next_page: 0,
  content_policy_schema: null,
  schema_loading: false,
};
